import React, { useEffect } from 'react';

import { injectIntl } from 'react-intl';
import moment from 'moment';
import logsEndpoint from 'app/api/services/logsEndpoint';
import { Container } from '@material-ui/core';
import { openFileByteArray } from '../../utils/forms/files';

function Logs() {

  useEffect(() => {
    const init = async () => {
      const response = await logsEndpoint.getAll();
      const now = moment().format('DD-MM-YYYY_-_hh:mm:ss');
      if (response.status === 200 && response.data) {
        openFileByteArray({ data: response.data, fileName: ('LOG_STIP_-_' + now + '.txt'), type: 'application/text' });
      }
    };
    init();
  }, []);

  return (
    <Container />
  );

}

export default injectIntl(Logs);
